module.exports = __webpack_public_path__ + "static/media/hh_logo_dark.c42a268c.svg";